module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.data), function(item, key) {
    return _c('swiper-slide', {
      key: key
    }, [_c('div', {
      staticClass: "btn-item-added"
    }, [_vm._v(_vm._s(item.name)), _c('a', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.removeTag(item.id, item.name)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-next",
    slot: "button-next"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aaecb51"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/Slider.vue
// module id = 719
// module chunks = 1